import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getCriteriaLimitedBlocks } from '../useBlockVisibility/helpers'
import { getScenarioCriteria } from './helpers'

const useScenarioCriteria = ({ layout, getBlockVisibility, criteriaOptions, blockSettings }) => {
  const { t } = useTranslation()
  const [disabledCriterionIds, setDisabledCriterionIds] = useState([])

  const toggleCriterion = criterionId => {
    setDisabledCriterionIds(previous => {
      if (previous.includes(criterionId)) return previous.filter(id => id !== criterionId)

      return [...previous, criterionId]
    })
  }

  const criteria = getScenarioCriteria({
    layout,
    getBlockVisibility,
    criteriaOptions,
    disabledCriterionIds,
    blockSettings,
    t,
  })

  const criteriaLimitedBlocks = getCriteriaLimitedBlocks({
    layout,
    getBlockVisibility,
    criteriaOptions,
    isCriterionActive: criterionId => !disabledCriterionIds.includes(criterionId),
  })

  return { criteria, toggleCriterion, criteriaLimitedBlocks }
}

export default useScenarioCriteria
